export default __webpack_public_path__ + "static/char-v-52-bcb823a04dd5c907ff090c734085858a.webp";